import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"small":"","depressed":"","color":"primary","loading":_vm.loading},on:{"click":_vm.updateVariants}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('Update Variants'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }